// scroll-animations.js
document.addEventListener("DOMContentLoaded", () => {
  const elementsToAnimate = document.querySelectorAll(".animate-on-scroll");
  
  if (!elementsToAnimate.length) return;

  const observerOptions = {
    root: null,
    rootMargin: "0px 0px -10% 0px", // Trigger slightly before it comes fully into view
    threshold: 0.1
  };

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add("is-visible");
        observer.unobserve(entry.target); // Unobserve so it only plays once
      }
    });
  }, observerOptions);

  elementsToAnimate.forEach(el => observer.observe(el));
});
